function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h9v9H0V0zm2 2v5h5V2H2zm-2 9h9v9H0v-9zm2 2v5h5v-5H2zm9-13h9v9h-9V0zm2 2v5h5V2h-5zm-2 9h9v9h-9v-9zm2 2v5h5v-5h-5z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZD0iTTAgMGg5djlIMFYwem0yIDJ2NWg1VjJIMnptLTIgOWg5djlIMHYtOXptMiAydjVoNXYtNUgyem05LTEzaDl2OWgtOVYwem0yIDJ2NWg1VjJoLTV6bS0yIDloOXY5aC05di05em0yIDJ2NWg1di01aC01eiIvPjwvc3ZnPg==";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/svg/view-tile.svg